import { useTranslation } from 'i18n';

import { AuthLayout } from '../AuthLayout/AuthLayout';

export const SignInPage = ({
  children,
  title,
  subtitle,
  logo,
}: {
  children: React.ReactNode;
  title?: string;
  subtitle?: string;
  logo: string;
}) => {
  const { t } = useTranslation('features');
  const { t: tCommon } = useTranslation('common');

  const resolvedTitle = title ?? t('auth.signInPage.title');
  const resolvedSubtitle = subtitle ?? t('auth.signInPage.subtitle', { values: { brandName: tCommon('brand.name') } });

  return (
    <AuthLayout title={resolvedTitle} subtitle={resolvedSubtitle} logo={logo}>
      {children}
    </AuthLayout>
  );
};
